import { ElMessageBox } from 'element-plus/es';
import 'element-plus/es/components/message-box/style/css';
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, unref as _unref } from "vue";
const _hoisted_1 = {
  class: "right"
};
const _hoisted_2 = {
  key: 1
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  key: 1
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 1,
  style: {
    "color": "#5186ef"
  }
};
const _hoisted_7 = {
  key: 0
};
const _hoisted_8 = {
  key: 1,
  style: {
    "color": "#5186ef"
  }
};
const _hoisted_9 = {
  key: 0
};
const _hoisted_10 = {
  key: 1,
  style: {
    "color": "#5186ef",
    "display": "inline"
  }
};
const _hoisted_11 = {
  class: "computeSelect"
};
const _hoisted_12 = {
  key: 0
};
const _hoisted_13 = {
  key: 1
};
import { nextTick, onMounted, reactive, ref, watch } from "vue";
import apis from "@/api";
import { ElMessage } from "element-plus";
import AccessoryUpload from '@/components/MoreUpload';
import common from "@/views/Home/MyNeeds/composables/common";
export default {
  __name: 'ContractSettlementAdd',
  props: {
    title: {
      type: String,
      default: '结算单明细',
      required: false
    },
    visible: {
      type: Boolean,
      default: false
    },
    contractId: {
      type: String
    },
    contract: {
      type: Object
    }
  },
  emits: ['submit', 'update:visible'],
  setup(__props, {
    emit: __emit
  }) {
    const emits = __emit;
    const multipleTableRef = ref();
    const props = __props;
    const headerStyle = ref({
      background: '#FAFAFA'
    });
    const confirmVisible = ref(false);
    const confirmSubmit = ref(false);
    const contractAreas = ref([]);
    const contractAreaAdmins = ref([]);
    const elLoading = ref(false);
    const uploadVisible = ref(false);
    const disabled = ref(false);
    const deleteByAccessoryId = ref(false);
    const computeMode = ref(1);
    const multipleSelection = ref([]);
    const formRef = ref(null);
    function validateSettlementRateDesc(rule, value, callback) {
      if (data.settlement.settlementRate < 100 && (!data.settlement.settlementRateDesc || !data.settlement.settlementRateDesc.trim())) {
        callback(new Error("请输入结算比例说明"));
      }
      callback();
    }
    function validateAdjustAfter(rule, value, callback) {
      if (data.settlement.settlementRate.length <= 0) {
        callback(new Error("请输入调整后的结算金额"));
      }
      if (!Number(data.settlement.adjustAfter)) {
        callback(new Error("请输入有效两位小数数字"));
      }
      const re = /^[0-9]\d*(\.\d{1,2})?$/;
      const rsCheck = re.test(data.settlement.adjustAfter.toString());
      if (!rsCheck) {
        callback(new Error("请输入有效两位小数数字"));
      }
      let mistake = Math.abs(Number(data.settlement.adjustAfter) - Number(data.settlement.rateAfter));
      mistake = Number(mistake.toFixed(6));
      if (mistake > Number('0.03')) {
        callback(new Error("差额修改不能大于0.03!"));
      }
      callback();
    }
    const data = reactive({
      rules: {
        settlementRate: [{
          required: true,
          message: "计算比例不能为空",
          trigger: "blur"
        }],
        settlementRateDesc: [{
          validator: validateSettlementRateDesc,
          trigger: "blur"
        }],
        adjustAfter: [{
          validator: validateAdjustAfter,
          trigger: "blur"
        }],
        statementArea: [{
          required: true,
          message: "请选择结算地区",
          trigger: "blur"
        }],
        settlementPersonnel: [{
          required: true,
          message: "请选择结算审核人",
          trigger: "blur"
        }]
      },
      upetClickId: undefined,
      settlement: {
        contractId: undefined,
        statementName: undefined,
        settlementDescription: undefined,
        settlementRateDesc: undefined,
        currentSettlementAmount: 0,
        settlementRate: 100,
        theorySettlementAmount: 0,
        rateAfter: 0,
        adjustAfter: 0,
        settlementPersonnel: undefined,
        statementArea: null
      },
      isShowBtn: false,
      tableData: [],
      pagination: {
        totalSize: 0,
        pageSize: 10,
        pageNo: 1
      },
      tabClickIndex: null,
      // 点击的单元格
      tabClickLabel: '',
      // 当前点击的列名
      activeNames: ['accessory'],
      uploadFiles: [],
      accessoryTableData: [],
      allUnit: 1
    });
    const getRateAfter = () => {
      return (data.settlement.theorySettlementAmount * data.settlement.settlementRate * 0.01).toFixed(2);
    };
    watch(() => data.settlement.settlementRate, settlementRate => {
      data.settlement.rateAfter = getRateAfter();
      data.settlement.adjustAfter = getRateAfter();
    }, {
      immediate: true
    });
    watch(() => data.settlement.statementArea, (newValue, oldValue) => {
      apis.getRolesUserList('contract_admin_' + newValue).then(res => {
        if (res.success) {
          const list = Array.isArray(res.data) ? res.data : [];
          contractAreaAdmins.value = list;
        } else {
          ElMessage.error(res.msg || '合同管理员查询失败');
        }
      }).catch(err => {
        ElMessage.error('合同管理员查询失败');
      });
    });
    const pricingUnitItem = [{
      value: 1,
      label: '/'
    }, {
      value: 2,
      label: '天'
    }, {
      value: 3,
      label: '周'
    }, {
      value: 4,
      label: '月'
    }, {
      value: 5,
      label: '季度'
    }, {
      value: 6,
      label: '年'
    }];
    const computedMode = [{
      value: 1,
      label: '含税总价 = 不含税总价 * 税率'
    }, {
      value: 2,
      label: '含税总价 = 含税单价 * 数量'
    }];
    const upetBlur = row => {
      defaultPricing(row);
      row.unitPriceExcludingTax = Number(row.unitPriceExcludingTax ? row.unitPriceExcludingTax.toString().replace(/[^0-9.]/g, "") : 0);
      row.unitPriceExcludingTax = Number(row.unitPriceExcludingTax.toFixed(6));
      row.unitPriceIncludingTax = (row.unitPriceExcludingTax * (1 + row.vatRate / 100)).toFixed(6);
      row.unitPriceIncludingTax = Number(row.unitPriceIncludingTax);
      row.totalExcludingTax = (row.settlementQuantity * row.unitPriceExcludingTax * row.pricingQuantity).toFixed(6);
      row.totalExcludingTax = Number(row.totalExcludingTax);
      setTotalIncludingTax(row);
      data.upetClickId = undefined;
    };
    const copyItem = row => {
      const item = JSON.parse(JSON.stringify(row));
      data.tableData.push(item);
    };
    const clickupet = id => {
      data.upetClickId = id;
    };
    const handleSizeChange = val => {
      data.pagination.pageSize = val;
      loadData();
    };
    const handleCurrentChange = val => {
      data.pagination.pageNo = val;
      loadData();
    };
    const handleUpload = () => {
      uploadVisible.value = true;
    };
    const downFile = row => {
      window.open(row.fileUrl);
    };
    const handleDeleteAccessory = row => {
      //将上传附件数据在临时展示中删除
      ElMessageBox.confirm('确定要删除该附件吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        data.uploadFiles = data.uploadFiles.filter(f => f.fileId !== row.fileId);
        data.accessoryTableData = data.uploadFiles;
      });
    };
    const checkConfirm = () => {
      confirmSubmit.value = true;
      if (!Number(data.settlement.adjustAfter)) {
        ElMessage.error('请输入有效两位小数数字!');
        confirmSubmit.value = false;
        return;
      }
      const re = /^[0-9]\d*(\.\d{1,2})?$/;
      const rsCheck = re.test(data.settlement.adjustAfter.toString());
      if (!rsCheck) {
        data.isShowBtn = true;
        ElMessage.error('请输入有效两位小数数字!');
        confirmSubmit.value = false;
        return;
      }
      let mistake = Math.abs(Number(data.settlement.adjustAfter) - Number(data.settlement.rateAfter));
      mistake = Number(mistake.toFixed(6));
      if (mistake > Number('0.03')) {
        ElMessage.error('差额修改不能大于0.03!');
        confirmSubmit.value = false;
        return;
      }
      confirmSubmit.value = false;
    };
    const confirmSubmitForm = () => {
      formRef.value.validate(valid => {
        console.log("confirmSubmitForm.valid:", valid);
        if (valid) {
          confirmSubmit.value = true;
          confirmVisible.value = false;
          data.settlement.currentSettlementAmount = Number(data.settlement.adjustAfter);
          data.settlement.theorySettlementAmount = Number(data.settlement.theorySettlementAmount);
          apis.addDetailed(data.settlement).then(res => {
            if (!res.success) {
              ElMessage.error(res.msg);
            } else {
              //若上传附件则保存附件
              if (data.uploadFiles && data.uploadFiles.length > 0) {
                data.uploadFiles.forEach(f => {
                  f.detailSettlementId = res.data.detailedInfo.id;
                  f.serviceType = '1';
                });
                apis.saveBatchDetailedSettlementAccessoryInfo(data.uploadFiles).then(res => {
                  if (res.success) {
                    data.uploadFiles = [];
                    data.accessoryTableData = [];
                  } else {
                    ElMessage.error(res.msg);
                  }
                }).catch(err => {
                  ElMessage.error(err);
                });
              }
              multipleSelection.value.forEach(function (item) {
                item.detailedId = res.data.detailedInfo.id;
              });
              apis.addSettlementInfoBatch(multipleSelection.value).then(res => {
                if (res.success) {
                  const updateDate = {
                    id: props.contractId,
                    statementStatus: 1
                  };
                  apis.updateContractInfo(updateDate).then(res => {
                    if (res.success) {
                      ElMessage.success('提交审核成功');
                    }
                  }).catch(err => {
                    ElMessage.error(err);
                  }).finally(() => {
                    data.settlement = {};
                    data.tableData = [];
                    loadData();
                    emits("submit");
                    emits('update:visible', false);
                    multipleSelection.value = [];
                  });
                } else {
                  ElMessage.error(res.msg);
                }
              }).catch(err => {
                ElMessage.error(err);
              });
            }
          }).finally(() => {
            confirmSubmit.value = false;
          });
        }
      });
    };
    const handlerUploadSuccess = files => {
      uploadVisible.value = false;
      if (files && files.length > 0) {
        let uploadFiles = [];
        files.forEach(f => {
          const name = f.fileName.substring(0, f.fileName.lastIndexOf("."));
          const item = {
            fileId: f.id,
            name: name,
            fileName: f.fileName,
            fileUrl: f.relativeUrl,
            upTime: f.uploadTime,
            upUser: f.operator,
            fileType: f.fileType
            //id结算单ID
          };
          uploadFiles.push(item);
        });
        data.uploadFiles = data.uploadFiles.concat(uploadFiles);
        console.info("uploadFiles:", data.uploadFiles);
        //将文件信息赋值给附件表格作为临时展示，提交审核后方可保存
        data.accessoryTableData = data.uploadFiles;
      } else {
        ElMessage.error('请先上传附件!');
      }
    };
    const loadData = () => {
      const params = {
        contractId: props.contractId,
        ...data.pagination
      };
      elLoading.value = true;
      apis.querySettlementList(params).then(res => {
        if (res.success) {
          const {
            records,
            size,
            total,
            current
          } = res.data;
          if (multipleSelection.value.length > 0) {
            data.tableData = [];
            data.tableData = data.tableData.concat(multipleSelection.value).concat(records);
            const select = multipleSelection.value;
            nextTick(() => {
              select.forEach(row => {
                multipleTableRef.value.toggleRowSelection(row, true);
              });
            });
          } else {
            data.tableData = records;
          }
          data.pagination = {
            totalSize: total,
            pageSize: size,
            pageNo: current
          };
        } else {
          ElMessage.error(res.msg);
        }
      }).catch(err => {
        ElMessage.error(err);
      }).finally(() => {
        elLoading.value = false;
      });
    };
    const tabClick = (row, column) => {
      switch (column.label) {
        case '增值税率':
          data.tabClickIndex = row.index;
          data.tabClickLabel = column.label;
          break;
        case '结算数量':
          data.tabClickIndex = row.index;
          data.tabClickLabel = column.label;
          break;
        case '时长':
          data.tabClickIndex = row.index;
          data.tabClickLabel = '计价维度';
        default:
          return;
      }
    };
    const isInteger = value => {
      if (!value) {
        return callback(new Error('输入不可以为空'));
      }
      setTimeout(() => {
        if (!Number(value)) {
          callback(new Error('请输入正整数'));
        } else {
          const re = /^[0-9]*[1-9][0-9]*$/;
          const rsCheck = re.test(value);
          if (!rsCheck) {
            callback(new Error('请输入正整数'));
          } else {
            callback();
          }
        }
      }, 0);
    };

    // 失去焦点初始化
    const taxRateInputBlur = rowData => {
      data.tabClickIndex = null;
      data.tabClickLabel = '';
      defaultPricing(rowData);
      if (!rowData.vatRate) {
        data.isShowBtn = true;
        ElMessage.error('税率请输入正整数');
      }
      setTimeout(() => {
        if (!Number(rowData.vatRate)) {
          data.isShowBtn = true;
          ElMessage.error('税率请输入正整数');
        } else if (Number(rowData.vatRate) === 0) {
          data.isShowBtn = true;
          ElMessage.error('税率请输入正整数');
        } else {
          const re = /^[0-9]\d*(\.\d{1,6})?$/;
          const rsCheck = re.test(rowData.vatRate);
          if (!rsCheck) {
            data.isShowBtn = true;
            ElMessage.error('税率请输入正整数');
          }
        }
      }, 0);
      data.isShowBtn = false;
      rowData.unitPriceIncludingTax = rowData.unitPriceExcludingTax + rowData.unitPriceExcludingTax * Number(rowData.vatRate) / 100;
      rowData.unitPriceIncludingTax = Number(rowData.unitPriceIncludingTax.toFixed(6));
      setTotalIncludingTax(rowData);
    };
    // 失去焦点初始化
    const inputBlur = rowData => {
      data.tabClickIndex = null;
      data.tabClickLabel = '';
      defaultPricing(rowData);
      // console.log("========",rowData.settlementQuantity)
      setTimeout(() => {
        if (Number.isNaN(parseFloat(rowData.settlementQuantity))) {
          data.isShowBtn = true;
          ElMessage.error('数量请输入正整数');
        } else {
          const re = /^[0-9]\d*(\.\d{1,6})?$/;
          const rsCheck = re.test(rowData.settlementQuantity);
          if (!rsCheck) {
            data.isShowBtn = true;
            ElMessage.error('数量请输入正整数');
          } else {
            callback();
          }
        }
      }, 0);
      data.isShowBtn = false;
      rowData.totalExcludingTax = (rowData.settlementQuantity * rowData.unitPriceExcludingTax * rowData.pricingQuantity).toFixed(6);
      rowData.totalExcludingTax = Number(rowData.totalExcludingTax);
      setTotalIncludingTax(rowData);
    };
    const pricingInputBlur = row => {
      data.tabClickIndex = null;
      data.tabClickLabel = '';
      if (!row.pricingQuantity) {
        data.isShowBtn = true;
        ElMessage.error('时长请输入正数');
        return;
      }
      if (Number.isNaN(parseFloat(row.pricingQuantity))) {
        data.isShowBtn = true;
        ElMessage.error('时长请输入正数');
        return;
      } else if (Number(row.pricingQuantity) === 0) {
        data.isShowBtn = true;
        ElMessage.error('时长请输入正数');
        return;
      } else {
        // 时长为正整数或正六位浮点数
        const re = /^[0-9]\d*(\.\d{1,6})?$/;
        const rsCheck = re.test(row.pricingQuantity);
        if (!rsCheck) {
          data.isShowBtn = true;
          ElMessage.error('时长请输入正数');
          return;
        }
      }
      defaultPricing(row);
      if (row.pricingQuantity > 1 && row.pricingUnit === 1) {
        row.pricingUnit = 2;
      }
      data.isShowBtn = false;
      row.totalExcludingTax = (row.settlementQuantity * row.unitPriceExcludingTax * row.pricingQuantity).toFixed(6);
      row.totalExcludingTax = Number(row.totalExcludingTax);
      setTotalIncludingTax(row);
    };
    const selectUnit = row => {
      defaultPricing(row);
      if (row.pricingUnit === 1) {
        row.pricingQuantity = 1;
      }
      row.totalExcludingTax = (row.settlementQuantity * row.unitPriceExcludingTax * row.pricingQuantity).toFixed(6);
      row.totalExcludingTax = Number(row.totalExcludingTax);
      setTotalIncludingTax(row);
    };
    const setTotalIncludingTax = row => {
      // 默认 含税总价 = 不含税总价 * 税率
      if (computeMode.value === 1) {
        row.totalIncludingTax = Number((row.totalExcludingTax * (1 + row.vatRate / 100)).toFixed(6));
        return;
      } else if (computeMode.value === 2) {
        // 含税总价 = 含税单价 * 数量
        row.totalIncludingTax = Number((row.settlementQuantity * row.unitPriceIncludingTax * row.pricingQuantity).toFixed(6));
      }
    };
    const selectAllUnit = () => {
      for (let item of data.tableData) {
        item.pricingUnit = data.allUnit;
        selectUnit(item);
      }
    };
    const computedAll = () => {
      for (let item of data.tableData) {
        if (item.pricingQuantity) {
          setTotalIncludingTax(item);
        }
      }
    };
    const defaultPricing = row => {
      if (!row.pricingUnit) {
        row.pricingUnit = 1;
      }
      if (!row.pricingQuantity) {
        row.pricingQuantity = 1;
      }
    };
    const close = () => {
      data.form = {};
      multipleSelection.value = [];
      emits('update:visible', false);
    };
    const initArea = () => {
      data.settlement.statementArea = props.contract.areaCode;
      const areas = props.contract.areaCodeList.split(',');
      for (const area of areas) {
        contractAreas.value.push({
          code: area,
          name: common().getAreaByCode(area)
        });
      }
    };
    onMounted(() => {
      loadData();
      initArea();
    });
    const handleSaveSettlement = () => {
      if (!data.settlement.statementName) {
        ElMessage.error('请输入结算单名称!');
        return;
      }
      if (multipleSelection.value.length === 0) {
        ElMessage.error('请勾选需要结算的商品!');
        return;
      }
      let sumAmount = 0;
      multipleSelection.value.forEach(function (item) {
        sumAmount = sumAmount + item.totalIncludingTax;
      });
      for (let item of multipleSelection.value) {
        if (!(item.totalExcludingTax === 0 || item.totalExcludingTax)) {
          ElMessage.error(`请填写'${item.productCategory}'的结算数量和计价维度`);
          return;
        }
      }
      data.settlement.theorySettlementAmount = Number(sumAmount.toFixed(6));
      data.settlement.settlementRate = 100;
      data.settlement = {
        ...data.settlement,
        settlementRateDesc: undefined,
        currentSettlementAmount: getRateAfter(),
        rateAfter: getRateAfter(),
        adjustAfter: getRateAfter(),
        contractId: props.contractId
      };
      confirmVisible.value = true;
      confirmSubmit.value = false;
    };
    const handleSelectionChange = val => {
      multipleSelection.value = val;
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_empty = _resolveComponent("el-empty");
      const _component_el_collapse_item = _resolveComponent("el-collapse-item");
      const _component_el_collapse = _resolveComponent("el-collapse");
      const _component_el_input_number = _resolveComponent("el-input-number");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        title: __props.title,
        "model-value": __props.visible,
        onClose: close,
        "close-on-press-escape": false,
        "destroy-on-close": true,
        width: "100%",
        fullscreen: ""
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: close
        }, {
          default: _withCtx(() => [...(_cache[21] || (_cache[21] = [_createTextVNode("取消", -1)]))]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleSaveSettlement,
          disabled: data.isShowBtn
        }, {
          default: _withCtx(() => [...(_cache[22] || (_cache[22] = [_createTextVNode("提交审核", -1)]))]),
          _: 1
        }, 8, ["disabled"])]),
        default: _withCtx(() => [_createElementVNode("div", null, [_createElementVNode("div", null, [_createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "结算单名称:"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              placeholder: "请输入结算单名称",
              modelValue: data.settlement.statementName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => data.settlement.statementName = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "结算说明:",
            style: {
              "margin-left": "50px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              placeholder: "请输入结算说明",
              modelValue: data.settlement.settlementDescription,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => data.settlement.settlementDescription = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createElementVNode("div", _hoisted_1, [_createVNode(_component_el_button, {
            type: "primary",
            onClick: _withModifiers(handleUpload, ["stop"])
          }, {
            default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode("上传附件", -1)]))]),
            _: 1
          })])]),
          _: 1
        })]), _createElementVNode("div", null, [_createElementVNode("div", null, [_createVNode(_component_el_table, {
          border: "",
          data: data.tableData,
          "default-expand-all": "",
          onCellClick: tabClick,
          onSelectionChange: handleSelectionChange,
          ref_key: "multipleTableRef",
          ref: multipleTableRef
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            type: "selection"
          }), _createVNode(_component_el_table_column, {
            fixed: "",
            label: "操作",
            "min-width": "60"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_button, {
              link: "",
              type: "primary",
              size: "small",
              onClick: $event => copyItem(scope.row)
            }, {
              default: _withCtx(() => [...(_cache[17] || (_cache[17] = [_createTextVNode("复制", -1)]))]),
              _: 1
            }, 8, ["onClick"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            fixed: "",
            prop: "ranking",
            label: "序号"
          }), _createVNode(_component_el_table_column, {
            fixed: "",
            prop: "productCategory",
            label: "产品大类/类别",
            "min-width": "100"
          }), _createVNode(_component_el_table_column, {
            fixed: "",
            prop: "projectContent",
            label: "产品小类/项目内容",
            "min-width": "200"
          }), _createVNode(_component_el_table_column, {
            fixed: "",
            prop: "standardSpecifications",
            label: "标准规格",
            "min-width": "200"
          }), _createVNode(_component_el_table_column, {
            fixed: "",
            prop: "unit",
            label: "报价单位"
          }), _createVNode(_component_el_table_column, {
            fixed: "",
            prop: "unitPriceExcludingTax",
            label: "不含税单价/元"
          }, {
            default: _withCtx(scope => [scope.row.id === data.upetClickId ? (_openBlock(), _createBlock(_component_el_input, {
              key: 0,
              modelValue: scope.row.unitPriceExcludingTax,
              "onUpdate:modelValue": $event => scope.row.unitPriceExcludingTax = $event,
              placeholder: "不含税单价/元",
              size: "mini",
              onBlur: $event => upetBlur(scope.row)
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])) : (_openBlock(), _createElementBlock("div", _hoisted_2, [!scope.row.curingPriceEt ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              onClick: $event => clickupet(scope.row.id),
              class: "font-can-click"
            }, _toDisplayString(scope.row.unitPriceExcludingTax), 9, _hoisted_3)) : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(scope.row.unitPriceExcludingTax), 1))]))]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            fixed: "",
            prop: "vatRate",
            label: "增值税率"
          }, {
            default: _withCtx(scope => [scope.row.index === data.tabClickIndex && data.tabClickLabel === '增值税率' ? (_openBlock(), _createElementBlock("span", _hoisted_5, [_createVNode(_component_el_input, {
              modelValue: scope.row.vatRate,
              "onUpdate:modelValue": $event => scope.row.vatRate = $event,
              maxlength: "300",
              placeholder: "请输入增值税率",
              size: "mini",
              onBlur: $event => taxRateInputBlur(scope.row)
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])])) : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(scope.row.vatRate) + "%", 1))]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            fixed: "",
            prop: "unitPriceIncludingTax",
            label: "含税单价/元"
          }), _createVNode(_component_el_table_column, {
            fixed: "",
            prop: "settlementQuantity",
            label: "结算数量",
            "min-width": "70"
          }, {
            default: _withCtx(scope => [scope.row.index === data.tabClickIndex && data.tabClickLabel === '结算数量' ? (_openBlock(), _createElementBlock("span", _hoisted_7, [_createVNode(_component_el_input, {
              modelValue: scope.row.settlementQuantity,
              "onUpdate:modelValue": $event => scope.row.settlementQuantity = $event,
              maxlength: "300",
              placeholder: "请输入结算数量",
              size: "small",
              onBlur: $event => inputBlur(scope.row)
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])])) : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(scope.row.settlementQuantity), 1))]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            fixed: "",
            label: "计价维度",
            "min-width": "200"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              fixed: "",
              label: "时长",
              "min-width": "70"
            }, {
              default: _withCtx(scope => [scope.row.index === data.tabClickIndex && data.tabClickLabel === '计价维度' ? (_openBlock(), _createElementBlock("span", _hoisted_9, [_createVNode(_component_el_input, {
                modelValue: scope.row.pricingQuantity,
                "onUpdate:modelValue": $event => scope.row.pricingQuantity = $event,
                maxlength: "300",
                placeholder: "请输入时长",
                onBlur: $event => pricingInputBlur(scope.row),
                size: "small"
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])])) : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(scope.row.pricingQuantity), 1))]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              fixed: "",
              label: "单位",
              "min-width": "130"
            }, {
              header: _withCtx(() => [_cache[18] || (_cache[18] = _createElementVNode("span", null, " 单位 ", -1)), _createElementVNode("span", null, [_createVNode(_component_el_select, {
                modelValue: data.allUnit,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => data.allUnit = $event),
                placeholder: "",
                style: {
                  "width": "70px"
                },
                onChange: selectAllUnit
              }, {
                default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(pricingUnitItem, item => {
                  return _createVNode(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]);
                }), 64))]),
                _: 1
              }, 8, ["modelValue"])])]),
              default: _withCtx(scope => [_createVNode(_component_el_select, {
                modelValue: scope.row.pricingUnit,
                "onUpdate:modelValue": $event => scope.row.pricingUnit = $event,
                placeholder: "",
                size: "small",
                onChange: $event => selectUnit(scope.row)
              }, {
                default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(pricingUnitItem, item => {
                  return _createVNode(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]);
                }), 64))]),
                _: 1
              }, 8, ["modelValue", "onUpdate:modelValue", "onChange"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            fixed: "",
            prop: "totalExcludingTax",
            label: "不含税合计/元",
            "min-width": "120"
          }), _createVNode(_component_el_table_column, {
            fixed: "",
            prop: "totalIncludingTax",
            label: "含税合计/元",
            "min-width": "130"
          }, {
            header: _withCtx(() => [_cache[19] || (_cache[19] = _createElementVNode("span", null, " 含税合计/元 ", -1)), _createElementVNode("span", _hoisted_11, [_createVNode(_component_el_select, {
              modelValue: computeMode.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => computeMode.value = $event),
              placeholder: "",
              onChange: computedAll
            }, {
              default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(computedMode, item => {
                return _createVNode(_component_el_option, {
                  key: item.value,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]);
              }), 64))]),
              _: 1
            }, 8, ["modelValue"])])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            "show-overflow-tooltip": "true",
            prop: "technicalStandard",
            label: "技术标准"
          }), _createVNode(_component_el_table_column, {
            "show-overflow-tooltip": "true",
            prop: "supplyServiceStandard",
            label: "供货服务标准"
          }), _createVNode(_component_el_table_column, {
            prop: "warrantyPeriod",
            label: "质保期"
          }), _createVNode(_component_el_table_column, {
            prop: "materialCategory",
            label: "物料类别"
          })]),
          _: 1
        }, 8, ["data"])]), _createElementVNode("div", null, [_createVNode(_component_el_pagination, {
          onSizeChange: handleSizeChange,
          onCurrentChange: handleCurrentChange,
          "page-sizes": [10, 20, 50, 100, 200, 500],
          "page-size": data.pagination.pageSize,
          total: data.pagination.totalSize,
          currentPage: data.pagination.pageNo,
          "onUpdate:currentPage": _cache[4] || (_cache[4] = $event => data.pagination.pageNo = $event),
          layout: "total, prev, pager, next, sizes, jumper"
        }, null, 8, ["page-size", "total", "currentPage"])])])]), _createVNode(_component_el_collapse, {
          modelValue: data.activeNames,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => data.activeNames = $event)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_collapse_item, {
            title: "附件信息",
            name: "accessory"
          }, {
            default: _withCtx(() => [data.accessoryTableData && data.accessoryTableData.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(_component_el_table, {
              data: data.accessoryTableData,
              style: {
                "width": "100%"
              },
              "header-cell-style": headerStyle.value
            }, {
              default: _withCtx(() => [_createVNode(_component_el_table_column, {
                prop: "name",
                label: "文件名"
              }), _createVNode(_component_el_table_column, {
                prop: "upTime",
                label: "上传时间"
              }), _createVNode(_component_el_table_column, {
                prop: "upUser",
                label: "上传人"
              }), _createVNode(_component_el_table_column, {
                label: "操作",
                width: "150"
              }, {
                default: _withCtx(scope => [_createVNode(_component_el_button, {
                  link: "",
                  size: "small",
                  type: "primary",
                  onClick: $event => handleDeleteAccessory(scope.row),
                  disabled: deleteByAccessoryId.value
                }, {
                  default: _withCtx(() => [...(_cache[20] || (_cache[20] = [_createTextVNode("删除 ", -1)]))]),
                  _: 1
                }, 8, ["onClick", "disabled"])]),
                _: 1
              })]),
              _: 1
            }, 8, ["data", "header-cell-style"])])) : (_openBlock(), _createElementBlock("div", _hoisted_13, [_createVNode(_component_el_empty, {
              description: "未上传附件信息",
              "image-size": "50"
            })]))]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"]), _createVNode(_unref(AccessoryUpload), {
          visible: uploadVisible.value,
          "onUpdate:visible": _cache[6] || (_cache[6] = $event => uploadVisible.value = $event),
          multiple: true,
          onUploadSuccess: handlerUploadSuccess
        }, null, 8, ["visible"]), _createVNode(_component_el_dialog, {
          title: "确认结算金额",
          "model-value": confirmVisible.value,
          width: "40%",
          onClose: _cache[15] || (_cache[15] = $event => confirmVisible.value = false),
          "close-on-press-escape": false
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form, {
            "label-width": "160px",
            rules: data.rules,
            model: data.settlement,
            ref_key: "formRef",
            ref: formRef
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "本次结算金额（理论）："
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                placeholder: "本次结算金额",
                modelValue: data.settlement.theorySettlementAmount,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => data.settlement.theorySettlementAmount = $event),
                disabled: ""
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "结算比例（%）：",
              prop: "settlementRate"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input_number, {
                modelValue: data.settlement.settlementRate,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => data.settlement.settlementRate = $event),
                precision: 2,
                step: 1,
                min: 0,
                max: 100
              }, {
                suffix: _withCtx(() => [...(_cache[23] || (_cache[23] = [_createElementVNode("span", null, "%", -1)]))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "结算金额（折算后）："
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: data.settlement.rateAfter,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => data.settlement.rateAfter = $event),
                disabled: ""
              }, null, 8, ["modelValue"])]),
              _: 1
            }), data.settlement.settlementRate < 100 ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: "结算比例说明：",
              prop: "settlementRateDesc"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                placeholder: "根据合同考核条款，考核分XX分，结算比例X%",
                modelValue: data.settlement.settlementRateDesc,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => data.settlement.settlementRateDesc = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
              label: "结算金额（调整后）：",
              prop: "adjustAfter"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                placeholder: "结算金额调整",
                modelValue: data.settlement.adjustAfter,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => data.settlement.adjustAfter = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "结算地区：",
              prop: "statementArea"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: data.settlement.statementArea,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => data.settlement.statementArea = $event),
                onChange: _cache[13] || (_cache[13] = $event => data.settlement.settlementPersonnel = null),
                placeholder: "选择结算地区"
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contractAreas.value, item => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: item.code,
                    label: item.name,
                    value: item.code
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "结算单审核人：",
              prop: "settlementPersonnel"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: data.settlement.settlementPersonnel,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => data.settlement.settlementPersonnel = $event),
                placeholder: "选择审核人"
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contractAreaAdmins.value, item => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: item.userId,
                    label: item.name,
                    value: item.userId
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["rules", "model"]), _createVNode(_component_el_button, {
            type: "primary",
            onClick: confirmSubmitForm,
            disabled: confirmSubmit.value
          }, {
            default: _withCtx(() => [...(_cache[24] || (_cache[24] = [_createTextVNode("提交审核", -1)]))]),
            _: 1
          }, 8, ["disabled"])]),
          _: 1
        }, 8, ["model-value"])]),
        _: 1
      }, 8, ["title", "model-value"]);
    };
  }
};